import Error from "../../helpers/Error";
import { SEND_NEW_SCHOOL_ENDPOINT } from "../../constants/ApiConstants";
import axios from "axios";

export default async function sendNewSchoolCall(fields: GenericObject, authorId: number, categories: SchoolCategory) {
    try {
        const response = await axios.post(SEND_NEW_SCHOOL_ENDPOINT, {
            fields,
            authorId,
            categories,
            taxonomy: "school-category",
            postType: "school",
        });
        return response.data;
    } catch (error: any) {
        throw new Error(error.response.data.message, error.response.data.code);
    }
}
